import api from '../utils/apiUtils';

const API_URL = '/home/';

// Fetch all homepage content
export const fetchHomeContent = async () => {
  try {
    const resp = await api.post(API_URL + 'user-home', {});
    const data = resp.data
    console.log(data);
    return data;
     } catch (error) {
     console.error('Error fetching home content:', error);
     throw error;
   } 
}; 

export const journeyRecommendation = async (input) => {
  try {
    const resp = await api.post('/ai/recommend-a-journey', { text: input });
    const data = resp.data
    console.log(data);
    return data;
  } catch (error) {
    console.error('Error fetching wellness assistant:', error);
    throw error;
  }
}